import React from 'react';
import { ReactEditor } from 'slate-react';
import { Location } from 'slate';
import { AulaPlugin } from '../plugins';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { AulaEditorInstance } from '../../types';
import { CloudFile } from '../../components/CloudFile/CloudFile';

export type CloudFileProviderPluginOpts = {
  name: string;
  elementType: string;
  icon: JSX.Element;
  onRequestFilePicker: (
    editor: AulaEditorInstance,
    location: Location,
    driveType?: string,
  ) => void;
  driveType?: string;
};

export const createCloudFileProviderPlugin =
  (options: CloudFileProviderPluginOpts): AulaPlugin =>
  (editableProps, editor, context) => {
    const { isVoid } = editor;
    const { elementType, onRequestFilePicker, icon, driveType } = options;

    editor.isVoid = (el) => el?.type === elementType || isVoid(el);

    const enabledGoogleDriveEnvs = [
      'rave',
      'coventry',
      'demo',
      'app',
      'staging',
      'pa-assessments',
      'pa-core',
      'pa-journey',
      'pa-system',
    ];
    const includeInBlockMenu =
      options.name !== 'Google Drive' ||
      enabledGoogleDriveEnvs.includes(context?.config?.institution || '');

    return {
      ...editableProps,
      blockMenu: {
        ...editableProps.blockMenu,
        File: {
          ...editableProps?.blockMenu?.File,
          ...(includeInBlockMenu && {
            [options.name]: ({
              text,
              element,
              attributes,
              children,
              onClose,
            }) => (
              <NestedMenuItem
                text={text}
                leftIcon={options.icon}
                key={text}
                attributes={{
                  ...attributes,
                  onClick: () => {
                    if (onClose) {
                      onClose();
                    }
                    options.onRequestFilePicker(
                      editor,
                      ReactEditor.findPath(editor, element),
                      driveType,
                    );
                  },
                }}
              >
                {children}
              </NestedMenuItem>
            ),
          }),
        },
      },
      renderElement: (props) => {
        const { element, attributes, children } = props;

        if (
          element.type !== options.elementType &&
          editableProps.renderElement
        ) {
          return editableProps.renderElement(props);
        }

        return (
          <div {...attributes}>
            <CloudFile
              element={element}
              cloudFileType={elementType}
              requestPicker={onRequestFilePicker}
              icon={icon}
            />
            {children}
          </div>
        );
      },
    };
  };
